import { render, staticRenderFns } from "./watchList.vue?vue&type=template&id=2c0019f6&scoped=true"
import script from "./watchList.vue?vue&type=script&lang=js"
export * from "./watchList.vue?vue&type=script&lang=js"
import style0 from "./watchList.vue?vue&type=style&index=0&id=2c0019f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0019f6",
  null
  
)

export default component.exports